module.exports = __webpack_public_path__ + "img/doctor.7d458260.png";